export default defineNuxtPlugin(() => {
	const { setBackgroundImageVar } = useOptimizedBackgroundImage();

	// URL original da imagem do mapa
	const originalImageUrl =
		'https://s3.us-east-2.amazonaws.com/public-assets.soupilar.com.br/web/map_placeholder.svg';

	// Configurar a imagem otimizada do mapa
	setBackgroundImageVar(originalImageUrl, 'map-placeholder-image-url', {
		format: 'webp',
		quality: 90,
		width: 1920,
		fit: 'cover'
	});
});
